import axios from 'axios';

/**
 * @typedef {object} Product
 * @property {string} productId
 * @property {string} locationId
 * @property {string} productName
 * @property {string} sku
 * @property {number} cost
 * @property {number} quantity
 * @property {string} lot
 * @property {string} expirationDate
 */

/**
 * @typedef {object} ScannedToReceiveRequest
 * @property {string} inventoryWarehouseId
 * @property {string} notes
 * @property {Array<Product>} items
 */

/**
 * @typedef {object} ScannedProduct
 * @property {string} productId
 * @property {string} name
 * @property {string} sku
 * @property {string} upc
 * @property {string} thumbnailUrl
 * @property {boolean} isBundle
 * @property {string} [locationId]
 * @property {Array<{componentProductId: string, sku: string, upc?: string, name: string, quantity: number, thumbnailUrl?: string}>} [bundleComponents]
 * @property {number} [matchedUoMId]
 * @property {Array<{productUoMId: number, uomTypeName: string, conversionFactor: number, parentProductUoMId: number|null, eaches: number, uomSku: string, barcode: string}>} [unitsOfMeasure]
 */

/**
 * @typedef {object} ScannedProductsResponse
 * @property {ScannedProduct} product
 */

/**
 * @param {string} skuOrUpc
 * @param {string} [inventoryWarehouseId]
 * @param {boolean} [includeUom]
 * @returns {Promise<ScannedProductsResponse>}
 */
export const getProductsBySkuOrUpc = async (skuOrUpc, inventoryWarehouseId, includeUom) => {
  const queryParams = new URLSearchParams();
  if (inventoryWarehouseId) queryParams.set('inventoryWarehouseId', inventoryWarehouseId);
  if (includeUom) queryParams.set('includeUom', 'true');
  const params = queryParams.toString() ? `?${queryParams.toString()}` : '';
  const response = await axios.get(`/scanToReceive/${encodeURIComponent(skuOrUpc)}${params}`);
  return response.data;
};

/**
 * @param {ScannedToReceiveRequest} data
 * @returns {Promise<{jobId: string}>} jobId
 */
export const submitScanToReceive = async (data) => {
  const response = await axios.post('/scanToReceive', data);
  return response.data;
};
